import {styled} from '@mui/material/styles'
import {Button, IconButton, Typography, Box, Table, Tab, Grid, Alert, Snackbar} from '@mui/material'
import TabList from '@mui/lab/TabList'

export const StyledTypography = styled(Typography)(() => ({
  fontSize: '14px',
  padding: '16px',
  marginLeft: '16px',
  fontWeight: 700
}))

export const StyledButton = styled(Button)(({theme}) => ({
  color: theme.palette.common.black,
  fontSize: '12px',
  fontWeight: 'bold'
}))

export const StyledTabList = styled(TabList)(() => ({
  marginLeft: '16px'
}))

export const StyledDiv = styled('div')(({theme}) => ({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  padding: '16px 16px 0px 16px'
}))

export const StyledIconButton = styled(IconButton)(() => ({
  fontSize: '12px',
  ':disabled': {
    color: 'grey'
  }
}))

export const StyledSaveAndGenerateButton = styled(Button)(({theme}) => ({
  border: `1px solid ${theme.palette.common.blue1}`,
  color: theme.palette.common.blue1,
  marginRight: '16px',
  '&:disabled': {
    color: 'grey',
    border: `1px solid ${theme.palette.common.blue1}`
  },
  '&:hover': {
    border: `1px solid ${theme.palette.common.blue1}`
  },
  fontSize: theme.typography.heading.fontSize.xs,
  padding: '5px 8px',
  textTransform: 'none'
}))

export const StyledSpan = styled('span')(({theme}) => ({
  display: 'inline-block',
  padding: '5px',
  borderRadius: '44px',
  backgroundColor: theme.palette.common.green,
  margin: '0 5px',
  fontSize: '11px',
  color: theme.palette.common.black
}))

export const StyledBox = styled(Box)(() => ({
  display: 'flex',
  justifyContent: 'flex-start',
  alignItems: 'center',
  marginBottom: '24px'
}))

export const StyledTable = styled(Table, {shouldForwardProp: (prop) => prop !== 'loading' && prop !== 'height'})(
  ({height, loading}) => ({
    marginTop: loading ? height / 2 : '',
    display: loading ? 'flex' : '',
    justifyContent: loading ? 'center' : ''
  })
)

export const StyledTab = styled(Tab)(({theme}) => ({
  textTransform: 'none',
  fontSize: theme.typography.heading.fontSize.xs
}))

export const StyledGrid = styled(Grid)(() => ({
  alignItems: 'center',
  justifyContent: 'space-between'
}))

export const StyledTabBox = styled(Box)(() => ({
  borderBottom: 1,
  borderColor: 'divider',
  padding: '10px'
}))

export const StyledAlertGrid = styled(Grid)(() => ({
  marginLeft: 'auto',
  marginRight: '24px'
}))

export const StyledAlert = styled(Alert)(({theme}) => ({
  backgroundColor: theme.palette.common.grey5,
  color: theme.palette.common.white,
  fontStyle: 'italic',
  fontSize: theme.typography.heading.fontSize.xxs,
  marginBottom: '24px',
  '.MuiAlert-icon': {color: theme.palette.common.white}
}))

export const StyledSnackbar = styled(Snackbar)(({theme}) => ({
  position: 'static',
  transform: 'none',
  zIndex: 100,
  '.MuiPaper-root': {
    padding: '6px 16px',
    marginRight: '28px'
  }
}))

export const StyledAlertSnackbar = styled(Alert)(({theme}) => ({
  width: '100%',
  padding: '6px 16px',
  '.MuiAlert-action .MuiSvgIcon-root': {color: theme.palette.common.black},
  '.MuiAlert-action': {padding: '2px 0 0 16px'}
}))
